const MONTHS = [
  'янв',
  'фев',
  'мар',
  'апр',
  'мая',
  'июн',
  'июл',
  'авг',
  'сен',
  'окт',
  'ноя',
  'дек',
];

export interface LocalParts {
  day: number;
  month: string;
  monthIndex: number;
  year: number;
  time: string;
  date: string;
}

export function localParts(iso: string, timeZone: string): LocalParts {
  const formatter = new Intl.DateTimeFormat('ru-RU', {
    timeZone,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  });

  const values: Record<string, string> = {};
  for (const part of formatter.formatToParts(new Date(iso))) {
    if (part.type !== 'literal') values[part.type] = part.value;
  }

  const monthIndex = Number(values.month) - 1;
  return {
    day: Number(values.day),
    month: MONTHS[monthIndex] ?? '',
    monthIndex,
    year: Number(values.year),
    time: `${values.hour}:${values.minute}`,
    date: `${values.year}-${values.month}-${values.day}`,
  };
}

export function formatDuration(minutes: number | null): string {
  if (!minutes || minutes <= 0) return '—';
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (hours === 0) return `${rest} мин`;
  if (rest === 0) return `${hours} ч`;
  return `${hours} ч ${rest} мин`;
}

export function formatDistance(km: number | null): string {
  if (!km) return '—';
  return `${km.toLocaleString('ru-RU')} км`;
}

export function plural(count: number, forms: [string, string, string]): string {
  const abs = Math.abs(count) % 100;
  const last = abs % 10;
  if (abs > 10 && abs < 20) return forms[2]!;
  if (last > 1 && last < 5) return forms[1]!;
  if (last === 1) return forms[0]!;
  return forms[2]!;
}
